export default "__VITE_ASSET__DGt_lq1B__"